import { Socket } from "phoenix";
import { SOCKET_URL } from "constants/constants";
import { createSlice } from "@reduxjs/toolkit";
import { getCurrentToken, signMeOut } from "slices/authSlice";
import {
  addSocketConnectionDrops,
  resetSocketConnectionDrops,
} from "slices/generalSlice";
import { beforeUnloadInterceptor } from "helpers/randomHelpers";
import { selectCurrentSpaceId } from "slices/spaceSlice";
import { selectGuestInfo } from "slices/generalSlice";
let dispatch = null;
let getState = null;
import("Store").then((module) => {
  dispatch = module.store.dispatch;
  getState = module.store.getState;
});

const initialState = {
  socketConnection: null,
};

// needs to be bound before instantiating the socket so we can stopImmediateProgoation of Before unload
window.addEventListener(
  "beforeunload",
  (e) => {
    console.log("before unload triggered");

    if (selectCurrentSpaceId(getState())) {
      console.log("before unload will intercept");
      return beforeUnloadInterceptor(e);
    }
  },
  {
    capture: true,
  }
);

let socket = new Socket(SOCKET_URL, {
  params: { token: null, guestInfo: null },
});

export const slice = createSlice({
  name: "socket",
  initialState,
  reducers: {
    setSocket: (state, action) => {
      state.socketConnection = action.payload;
    },
  },
});

/////////////////////////// MAINTAINING SOCKET TOCKEN
let socketMaintainLoop = null;
const startMaintainSocketToken = () =>
  new Promise((res) => {
    if (socketMaintainLoop) {
      clearInterval(socketMaintainLoop);
      socketMaintainLoop = null;
    }
    // do so immediately
    // renew 1min intervals
    setSocketToken().then(() => {
      socketMaintainLoop = setInterval(setSocketToken, 1000 * 60);
      res();
    });
  });

function stopMaintainSocketToken() {
  clearInterval(socketMaintainLoop);
  socketMaintainLoop = null;
  socket.params().guestInfo = null;
  socket.params().token = null;
}

function setSocketToken() {
  return new Promise((res) => {
    const guestInfo = selectGuestInfo(getState());
    if (guestInfo) {
      socket.params().guestInfo = {
        guid: guestInfo.guid,
        code: guestInfo.code,
        name: guestInfo.name,
      };
      socket.params().token = null;
      res();
      return;
    }
    getCurrentToken()
      .then((idtoken) => {
        socket.params().guestInfo = null;
        socket.params().token = idtoken;
        res();
      })
      .catch(() => {
        window.efs_debug && window.log("Failed to set the socket token");
      });
  });
}
///////////////////////////

export const setupSocketConnection = () =>
  new Promise((resolve) => {
    window.efs_debug && window.log("Setting Up Socket Connection");

    startMaintainSocketToken().then(() => {
      window.efs_debug && window.log("Socket Maintaining");

      socket.onOpen(() => {
        window.efs_debug && window.log("Socket Connection Opened");
        window.socky = socket;
        resolve();
        if (getState().general.socketConnectionDrops > 0) {
          dispatch(resetSocketConnectionDrops());
        }
        window.log("the socket was opened");
      });
      socket.onError(() => {
        window.efs_debug &&
          window.log("there was an error with the connection!");
      });
      socket.onClose(() => {
        window.efs_debug && window.log("the connection dropped");
        dispatch(addSocketConnectionDrops());
        window.efs_debug &&
          window.log(
            "Socket drops: " + getState().general.socketConnectionDrops
          );
        if (getState().general.socketConnectionDrops > 30) signMeOut();
      });
      socket.connect();
    });
  });

export function severSocketConnection() {
  stopMaintainSocketToken();
  socket.disconnect(() => {
    console.info("the socket connection was severed");
  });
}

export const { setSocket } = slice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`
export const selectSocket = () => socket;

export default slice.reducer;
